import notificationTypes from './notificationTypes';

import {
  fetchNotifications,
  markNotificationRead,
  markNotificationsSeen,
} from '../../services/notificationServices';

const PAGE_SIZE = 20;

export const addNotification = (notification) => ({
  type: notificationTypes.ADD_NOTIFICATION,
  payload: notification,
});

export const updateNotificationCounts = (counts) => ({
  type: notificationTypes.UPDATE_NOTIFICATION_COUNTS,
  payload: counts,
});

export const fetchNotificationsStart =
  ({ authToken, cursor, append = false } = {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: notificationTypes.FETCH_NOTIFICATIONS_START,
        meta: { append },
      });
      const response = await fetchNotifications({
        authToken,
        cursor,
        take: PAGE_SIZE,
      });
      dispatch({
        type: notificationTypes.FETCH_NOTIFICATIONS_SUCCESS,
        payload: {
          ...response,
          append,
        },
      });
    } catch (err) {
      dispatch({
        type: notificationTypes.FETCH_NOTIFICATIONS_FAILURE,
        payload: err.message,
      });
    }
  };

export const markNotificationAsRead =
  ({ authToken, notificationId }) =>
  async (dispatch) => {
    dispatch({
      type: notificationTypes.MARK_NOTIFICATION_AS_READ,
      payload: notificationId,
    });
    try {
      await markNotificationRead({ authToken, notificationId });
    } catch (err) {
      console.warn(err.message);
    }
  };

export const markNotificationsSeenStart = (authToken) => async (dispatch) => {
  dispatch({ type: notificationTypes.MARK_NOTIFICATIONS_SEEN });
  try {
    await markNotificationsSeen(authToken);
  } catch (err) {
    console.warn(err.message);
  }
};

export const clearNotifications = () => ({
  type: notificationTypes.CLEAR_NOTIFICATIONS,
});
